import React, { useEffect, useState } from 'react';
import { initFacebookApi } from '../../../../domain/facebook/facebook-marketing-provider';
import { getData } from '../dal/data-service';
import { IUserWidget } from '../interfaces';
import Preloader from '../../../../ui/svg/common/preloader';
import { getShareURL } from '../domain/refer-friend-provider';
import Copy from './copy';
import { rootActions, useAppDispatch, useAppSelector } from '../dal/store';
import SocialButtons from './social-buttons';
import Description from './description';
import EmailForm from './email-form';
import { getGdprCookie } from '../../../gdpr/domain/gdpr-provider';
import { getIsChina } from '../../../../domain/hidden-data-provider';

interface IReferWidget {
    widgetID: number;
    classes?: string;
}

const ReferWidget = (props: IReferWidget) => {

    const dispatch = useAppDispatch();

    const { widgetID } = props;
    const [ loading, setLoading] = useState(true);

    const emailFormVisible = useAppSelector(store => store.root.emailFormVisible);
    const userWidget = useAppSelector(store => store.root.userWidget);

    // const isChina = useAppSelector(store => store.root.isChina);
    // const isGdprFunctional = useAppSelector(store => store.root.isGdprFunctional);

    const isGdprFunctional = getGdprCookie().IsFunctional;
    const isChina = getIsChina();

    useEffect(() => {
        (async () => {
            if(!isChina && isGdprFunctional){
                initFacebookApi();
            }

            setLoading(true);
            const response = await getData(widgetID);
            setLoading(false);

            if(!response || response.statusCode !== 200 || !response.data.isValid || !response.data.relatedData){
                return;
            }

            const _userWidget: IUserWidget = response.data.relatedData.userWidget;

            dispatch(
                rootActions.main({
                    shareUrl: getShareURL(_userWidget.shortURL),
                    userWidget: _userWidget,
                })
            );

        })();
    }, [widgetID, dispatch, isChina, isGdprFunctional]);

    return (
        <div className={`${ props.classes ? props.classes : 'shadow-md border rounded px-6 py-6 text-center my-4 max-w-full mx-auto' }`} style={{
            width: '700px'
        }}>
            <Description />

            { loading && <Preloader width="25px" height="25px" color="#4f4f4f" /> }

            {
                !loading &&
                (
                    <>
                        {
                            !emailFormVisible && (
                                <>
                                    <SocialButtons />
                                    <Copy />
                                </>
                            )
                        }

                        { emailFormVisible && <EmailForm /> }
                    </>
                )
            }

            <p className="flex">
                <a href={ userWidget?.tcurl || '' } className="underline text-blue-200 text-sm">Terms & Conditions</a>
            </p>
        </div>
    )
};

export default ReferWidget;